var SearchBar = require('./SearchBar');

module.exports = SearchBar;
